import React, { useState } from "react";
import { Form, ModalBuilder, Table } from "@redriver/cinnamon";
import {
  approveClientChangeRequest,
  getClientChangeRequest,
  rejectClientChangeRequest,
} from "features/Companies/Customers/Change Requests/actions";
import ComparisonBox from "features/Companies/Customers/Change Requests/ComparisonBox";
import { TranslatedModal } from "features/../../../shared/components/modals";
import WarningBanner from "features/Companies/Customers/Change Requests/WarningBanner";
import { Button, Icon } from "semantic-ui-react";
import { useDispatch } from "react-redux";

const ViewRequest = ({ requestId, onSubmitted }) => {
  const dispatch = useDispatch();
  const [isSubmittingApproval, setIsSubmittingApproval] = useState(false);
  const [isSubmittingRejection, setIsSubmittingRejection] = useState(false);

  return (
    <ModalBuilder
      withForm
      loadAction={getClientChangeRequest}
      loadParams={{ requestId: requestId }}
      loadTransform={(data) => data.comparisonChecklist}
      renderTrigger={(showModal) => (
        <Table.MenuItem text="Review" primary onClick={showModal} />
      )}
      renderModal={(modalProps, formProps, state, events) => (
        <TranslatedModal.Add
          {...modalProps}
          size="large"
          header={
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Icon
                name="close"
                color="red"
                style={{ cursor: "pointer", lineHeight: "1.6rem" }}
                onClick={() => events.onCancel()}
              />
            </div>
          }
          className="data-check-modal custom-actions"
        >
          <Form {...formProps}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                paddingLeft: 25,
                paddingRight: 25,
              }}
            >
              <WarningBanner />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <ComparisonBox
                  header="CRM Customer Details"
                  {...formProps.value}
                  isCrm={true}
                />
                <ComparisonBox
                  header="Opal Customer Details"
                  {...formProps.value}
                  isCrm={false}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 14,
                }}
              >
                <div style={{ flexGrow: 1 }}>
                  <Form.TextArea label="Reason" field="reason" fluid />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "14px",
                    height: "max-content",
                  }}
                >
                  <Button
                    loading={isSubmittingRejection}
                    negative
                    disabled={
                      !formProps.value.reason ||
                      formProps.value.reason.length < 1
                    }
                    onClick={async () => {
                      setIsSubmittingRejection(true);
                      const { success } = await dispatch(
                        rejectClientChangeRequest(
                          requestId,
                          formProps.value.reason,
                        ),
                      );
                      if (success) {
                        setIsSubmittingRejection(false);
                        onSubmitted();
                        await events.onSubmit();
                      } else {
                        setIsSubmittingRejection(false);
                      }
                    }}
                  >
                    Reject
                  </Button>
                  <Button
                    loading={isSubmittingApproval}
                    positive
                    onClick={async () => {
                      setIsSubmittingApproval(true);
                      const { success } = await dispatch(
                        approveClientChangeRequest(requestId),
                      );
                      if (success) {
                        setIsSubmittingApproval(false);
                        onSubmitted();
                        await events.onSubmit();
                      } else {
                        setIsSubmittingApproval(false);
                      }
                    }}
                  >
                    Approve
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </TranslatedModal.Add>
      )}
    />
  );
};
export default ViewRequest;
